<template>
    <div>
        <div class="alert alert-warning">
            <h3 class="h5">TODO:</h3>
            <ul class="mb-0">
                <li>On blur, let focus go to other tabindexed elements if clicked</li>
            </ul>
        </div>

        <b-btn id="exPopover3" variant="primary" ref="button">Tooltip</b-btn>

        <b-popover target="exPopover3" placement="bottomleft" triggers="click blur" @shown="onShown" @hide="onHide">
            <template slot="title"><span class="h4">Title of Tooltip</span></template>

            <form class="location-search">
                <div class="location-search__fields">
                    <div class="form-group">
                        <label for="">Zip Code</label>
                        <input type="text" ref="input1" class="form-control" id="" placeholder="Zip Code">
                    </div>

                    <span class="location-search__or">or</span>

                    <div class="form-group">
                        <label for="">State</label>
                        <input type="text" class="form-control" id="" placeholder="State">
                    </div>
                </div>

                <button class="location-search__search btn btn-tertiary btn-round" v-on:keyup="closeToolTip()" type="submit">Search</button>
            </form>
        </b-popover>
    </div>
</template>

<script>
    export default {
        methods: {
            onShown() {
                this.focusRef(this.$refs.input1);
            },
            onHide() {
                this.focusRef(this.$refs.button);
            },
            closeToolTip() {
                this.focusRef(this.$refs.button);
            },
            focusRef(ref) {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// demo/ui-kit/tooltip.vue